import { getServices } from '../../../../../infra/startup';

export default function valueFunctionQueryParam(
  value: Record<string, any>
): boolean {
  const { URLService } = getServices() || {};

  const currentPathDescription = URLService.getCurrentPathDescription();

  return URLService.isSearchIncluded(value, currentPathDescription?.search);
}
